import { NgModule, AfterViewInit, LOCALE_ID, Injectable, ErrorHandler } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';

import { registerLocaleData } from '@angular/common';
import localeTr from '@angular/common/locales/tr';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeFa from '@angular/common/locales/fa';
import localePl from '@angular/common/locales/pl';
import localeVi from '@angular/common/locales/vi';
import localeRu from '@angular/common/locales/ru';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeEl from '@angular/common/locales/el';
import localeDa from '@angular/common/locales/da';
import localeBg from '@angular/common/locales/bg';

import localeIt from '@angular/common/locales/it';
import localePt from '@angular/common/locales/pt';
import localeSq from '@angular/common/locales/sq';

import localeRo from '@angular/common/locales/ro';

import { FormsModule } from '@angular/forms';
import { AdminMenuComponent } from '@app/comp/adminScreen/admin.menu.component';
import { NumericKeyboardComponent } from '@app/comp/adminScreen/numeric.keyboard.component';
import { AngularMyDatePickerModule } from 'angular-mydatepicker';
import { CoreComponent } from './core.component';
import { AllScreen } from '~/legacy/ts/allscreen/allscreen';
import { PrintCreditVoucher } from '~/legacy/ts/print_credit_voucher/print_credit_voucher';
import { PrintSlip } from '~/legacy/ts/print_slip/print_slip';
import { PrintSlipCashout } from '~/legacy/ts/print_slip_cashout/print_slip_cashout';
import { PrintCashBoxClosed } from '~/legacy/ts/print_cashboxclosed/print_cashboxclosed';
import { BettingSlip } from '~/legacy/ts/bettingslip/bettingslip';
import { SecondScreen } from '~/legacy/ts/secondscreen/secondscreen';

import { BettingSlipSystemModal } from '~/legacy/ts/bettingslip_system_modal/bettingslip_system_modal';
import { BettingSlipCalculatorModal } from '~/legacy/ts/bettingslip_calculator_modal/bettingslip_calculator_modal';
import { BettingSlipBalanceModal } from '~/legacy/ts/bettingslip_balance_modal/bettingslip_balance_modal';
import { BettingSlipBalanceInfoModal } from '~/legacy/ts/bettingslip_balance_info_modal/bettingslip_balance_info_modal';

import { PayoutModal } from '~/legacy/ts/payout_modal/payout_modal';
import { InfoModal } from '~/legacy/ts/info_modal/info_modal';
import { LanguageModal } from '~/legacy/ts/language_modal/language_modal';
import { LiveBets } from '~/legacy/ts/livebets/livebets';
import { LiveBetsKeyboardSearchModal } from '~/legacy/ts/livebets_keyboard_search_modal/livebets_keyboard_search_modal';
import { ResultsModal } from '~/legacy/ts/results_modal/results_modal';
import { SettingsPassword } from '~/legacy/ts/settingsPassword_Modal/settingsPassword_Modal';
import { MainFixture } from '~/legacy/ts/mainfixture/mainfixture';
import { AntiForgeryToken } from '~/legacy/ts/antiforgerytoken/antiforgerytoken';
import { SportFooter } from '~/legacy/ts/sportfooter/sportfooter';
import { SportHeader } from '~/legacy/ts/sportheader/sportheader';

import { SportCountryModal } from '~/legacy/ts/sportcountry_modal/sportcountry_modal';
import { SportTopLeaguesModal } from '~/legacy/ts/sporttopleagues_modal/sporttopleagues_modal';
import { PrintLastSlip } from '~/legacy/ts/print_lastSlip/print_lastSlip';
import { PrintLastPayout } from '~/legacy/ts/print_lastPayout/print_lastPayout';
import { LiveCashoutModal } from '~/legacy/ts/live_cashout_modal/live_cashout_modal';
import { ReadPayoutModal } from '~/legacy/ts/readPayout_modal/readPayout_modal';

import { SlipDetail } from '~/legacy/ts/slipdetail/slipdetail';
import { CashoutDetail } from '~/legacy/ts/cashoutdetail/cashoutdetail';
import { Explanation } from '~/legacy/ts/explanation_modal/explanation_modal';

import { CustomerTransaction } from '~/legacy/ts/customer_transaction/customer_transaction';
import { routing } from './app.routing';
import { TerminalKeyboardModal } from '~/legacy/ts/terminal_keyboard_modal/terminal_keyboard_modal';

import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { CoreService } from '~/legacy/ts/services/core.service';
import { LoginService } from '~/legacy/ts/login/services/login.service';
import { CategoriesService } from '~/legacy/ts/categories/services/categories.service';

import { GroupByCategoryName } from '~/legacy/ts/pipes/category_name/category_name';
import { GroupByEventName } from '~/legacy/ts/pipes/event_name/event_name';
import { GroupByEventDate } from '~/legacy/ts/pipes/event_date/event_date';

import { GroupByDate } from '~/legacy/ts/pipes/group_dates/group_dates';
import { GroupByTime } from '~/legacy/ts/pipes/group_time/group_time';
import { GroupByName } from '~/legacy/ts/pipes/group_name/group_name';
import { GroupBySplitName } from '~/legacy/ts/pipes/group_name/group_name_split';
import { GroupByOddsType } from '~/legacy/ts/pipes/odds_type/odds_type';
import { GroupBySlipId } from '~/legacy/ts/pipes/slipid/groupbyslipid';
import { OrderBySpecialBetValue } from '~/legacy/ts/pipes/sortpipe/sortpipe';
import { GroupBySportName } from '~/legacy/ts/pipes/sport_name/sport_name';
import { GroupBySportName2 } from '~/legacy/ts/pipes/sport_name2/sport_name2';
import { GroupByTournamentName } from '~/legacy/ts/pipes/tournament_name/tournament_name';
import { LiveBetFooter } from '~/legacy/ts/livebetfooter/livebetfooter';
import { Login } from '~/legacy/ts/login/login';
import { Tournaments } from '~/legacy/ts/tournaments/tournaments';

import { PayoutLimitModal } from '~/legacy/ts/payout_limit_modal/payout_limit_modal';
import { CustomerCardMessageModal } from '~/legacy/ts/customer_card_message_modal/customer_card_message_modal';
import { MessageModal } from '~/legacy/ts/message_modal/message_modal';

import { environment } from '../environments/environment';
import { DropdownMenu } from '~/modules/dropdown.menu';
import { OutsideListener } from '~/directives/outside.listener';
import { HeaderTop } from '@app/comp/headers/headerTop';
import { MainFixtureView } from '@app/comp/matchView/mainFixtureView';
import { PreFixture } from '@app/comp/matchView/fixtureView/pre.fixture';
import { translatePipe, translationHelper } from '~/helpers/translation.helper';
import { MatchRow } from '@app/comp/matchView/rowView/match.row';
import { uiHelper } from '~/helpers/ui.helper';
import { OddTypeSelector } from '@app/comp/headers/oddTypeSelector';
import { OddConstant } from '~/constant/odd.constant';
import { OddView } from '@app/comp/matchView/rowView/odd.view';
import { LiveFixtures } from '@app/comp/matchView/fixtureView/live.fixture';
import { UiConstant } from '~/constant/ui.constant';
import { ScoreView } from '@app/comp/matchView/rowView/score.view';
import { GetOddData } from '~/modules/getOddData';
import { MatchRow2nd } from '@app/comp/matchView/rowView/match.row.2nd';
import { GetOddDataAll } from '~/modules/getOddData.all';
import { ExpandView } from '@app/comp/matchView/rowView/expand.view';
import { NgxMasonryModule } from 'ngx-masonry';
import { BettingSlipView } from '@app/comp/bettingSlip/betting.slip';
import { scoreBox } from '@app/comp/scoreBox/scoreBox';
import { LazyForDirective } from '~/directives/lazy.load';
import { InlineSVGModule } from 'ng-inline-svg';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { StandingsModal } from './components/standings-modal/standings-modal';
import { environment as versioning } from '../environments/version';
import { LiveTrackerModal } from '@app/comp/livetracker-modal/livetracker-modal';

import * as Sentry from '@sentry/browser';
import { TicketKeyboardModal } from '@app/comp/ticket-keyboard-modal/ticket-keyboard-modal';
import { QrModal } from '@app/comp/qr-modal/qr-modal';
import { QRCodeModule } from 'angularx-qrcode';
import { ElectronService } from 'ngx-electron';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { WebWorkerService } from './modules/workers/web-worker.service';
import { TransactionsModal } from '@app/comp/transactions-modal/transactions-modal';
import { SortByPipe } from '~/legacy/ts/pipes/sort-by-pipe/sort-by-pipe';
import { SlipDuplicateModal } from '@app/comp/slip-duplicate-modal/slip-duplicate-modal';
import { BarcodeCardModal } from '@app/comp/barcodecard-modal/barcodecard-modal';
import { AllScreenHeader } from '@app/comp/headers/AllScreenHeader';
import { QrComponent } from './legacy/ts/qr/qr.component';
import { OutRightsFixtureView } from './components/matchView/outRightsFixtureView';
import { OutRightsFixture } from './components/matchView/fixtureView/outrights.fixture';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
    constructor() {}

    handleError(error) {
        Sentry.captureException(error.originalError || error);
        throw error;
    }
}
export function provideErrorHandler() {
    console.log('ENV:', environment.production);
    if (environment.production) {
        Sentry.init({
            dsn: 'https://452e900ceafa411eaf8d5a3adc46feaf@sentry.io/1415440',
            release: 'terminal@' + versioning.version,
        });
        return new SentryErrorHandler();
    } else {
        return new ErrorHandler();
    }
}

@Injectable()
export class localizationInit {
    public LANGCODE = 'en';

    constructor(private _Localization: translationHelper) {
        this.LANGCODE = this._Localization.LANGCODE;
        console.log('this._Localization.LANGID', this._Localization.LANGID);
        if (this._Localization.LANGID == 2) {
            registerLocaleData(localeEn);
        } else if (this._Localization.LANGID == 3) {
            registerLocaleData(localeTr);
        } else if (this._Localization.LANGID == 6) {
            registerLocaleData(localeDe);
        } else if (this._Localization.LANGID == 8) {
            registerLocaleData(localeFa);
            //jalaali.loadPersian({ usePersianDigits: true });
        } else if (this._Localization.LANGID == 5) {
            registerLocaleData(localeRu);
            //jalaali.loadPersian({ usePersianDigits: true });
        } else if (this._Localization.LANGID == 12) {
            registerLocaleData(localePl);
            this.LANGCODE = 'pl';
            console.log('pl register');
        } else if (this._Localization.LANGID == 22) {
            registerLocaleData(localeIt);
            this.LANGCODE = 'it';
        } else if (this._Localization.LANGID == 14) {
            registerLocaleData(localeFr);
            this.LANGCODE = 'fr';
        } else if (this._Localization.LANGID == 19) {
            registerLocaleData(localeDa);
            this.LANGCODE = 'da';
        } else if (this._Localization.LANGID == 17) {
            registerLocaleData(localeBg);
            this.LANGCODE = 'bg';
        } else if (this._Localization.LANGID == 15) {
            registerLocaleData(localeEl);
            this.LANGCODE = 'el';
        } else if (this._Localization.LANGID == 7) {
            registerLocaleData(localeEs);
            this.LANGCODE = 'es';
        } else if (this._Localization.LANGID == 11) {
            registerLocaleData(localePt);
            this.LANGCODE = 'pt';
        } else if (this._Localization.LANGID == 16) {
            registerLocaleData(localeSq);
            this.LANGCODE = 'sq';
        } else if (this._Localization.LANGID == 20) {
            registerLocaleData(localeRo);
            this.LANGCODE = 'ro';
        } else {
            registerLocaleData(localeEn);
        }
    }

    getLanguage(): string {
        return this.LANGCODE;
    }
}

@NgModule({
    imports: [
        BrowserModule,
        routing,
        HttpClientModule,
        FormsModule,
        NgxMasonryModule,
        InlineSVGModule.forRoot(),
        VirtualScrollerModule,
        AngularMyDatePickerModule,
        QRCodeModule,
        NgIdleKeepaliveModule.forRoot(),
    ],
    declarations: [
        CoreComponent,
        AllScreen,
        BettingSlip,
        InfoModal,
        LanguageModal,
        LiveBets,
        MainFixture,
        //SportBets,
        GroupByEventName,
        GroupByCategoryName,
        GroupByDate,
        GroupByName,
        PrintCashBoxClosed,
        PrintLastPayout,
        ReadPayoutModal,
        GroupBySplitName,
        GroupByOddsType,
        GroupBySlipId,
        Explanation,
        CashoutDetail,
        SlipDetail,
        OrderBySpecialBetValue,
        GroupBySportName,
        GroupBySportName2,
        GroupByTournamentName,
        Login,
        Tournaments,
        AntiForgeryToken,
        SportFooter,
        HeaderTop,
        DropdownMenu,
        LiveBetFooter,
        SettingsPassword,
        TerminalKeyboardModal,
        PrintLastSlip,
        //SportSoccer,
        SportHeader,
        //SportBasketball,
        //SportBaseball,
        //SportFootball,
        //SportFutsal,
        //SportHandball,
        //SportIceHockey,
        //SportTennis,
        //SportVolleyball,
        SportCountryModal,
        SportTopLeaguesModal,
        BettingSlipSystemModal,
        BettingSlipCalculatorModal,
        BettingSlipBalanceModal,
        BettingSlipBalanceInfoModal,
        LiveBetsKeyboardSearchModal,
        LiveCashoutModal,
        PrintSlip,
        PrintSlipCashout,
        PrintCreditVoucher,
        ResultsModal,
        PayoutModal,
        SecondScreen,
        CustomerTransaction,
        GroupByTime,
        GroupByEventDate,
        PayoutLimitModal,
        CustomerCardMessageModal,
        MessageModal,
        OutsideListener,
        MainFixtureView,
        OutRightsFixtureView,
        PreFixture,
        OutRightsFixture,
        MatchRow,
        OddTypeSelector,
        OddView,
        LiveFixtures,
        ScoreView,
        MatchRow2nd,
        ExpandView,
        BettingSlipView,
        scoreBox,
        LazyForDirective,
        translatePipe,
        AdminMenuComponent,
        NumericKeyboardComponent,
        StandingsModal,
        LiveTrackerModal,
        TicketKeyboardModal,
        QrModal,
        TransactionsModal,
        SortByPipe,
        SlipDuplicateModal,
        BarcodeCardModal,
        AllScreenHeader,
        QrComponent,
    ],
    bootstrap: [CoreComponent],
    providers: [
        localizationInit,
        {
            provide: LOCALE_ID,
            deps: [localizationInit],
            useFactory: localizationInit => localizationInit.getLanguage(),
        },
        CoreService,
        TournamentsService,
        LoginService,
        CategoriesService,
        translationHelper,
        uiHelper,
        OddConstant,
        UiConstant,
        GetOddData,
        GetOddDataAll,
        ElectronService,
        WebWorkerService,
        { provide: ErrorHandler, useFactory: provideErrorHandler },
    ],
})
export class AppModule implements AfterViewInit {
    ngOnInit() {}

    ngAfterViewInit() {}
}
